import autobind from 'autobind-decorator';
import * as React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {Alert, Button, DatePicker, Empty, Form, Icon, Row, Select, Spin} from 'antd';
import {connect} from 'redux-scaffolding-ts';
import {Query} from 'src/core/stores/dataStore';
import 'react-splitter-layout/lib/index.css';
import {formatMessage} from 'src/core/services/http.service';
import ProjectReportTable from '../../../components/project-report-table';
import ProjectReportChart from '../../../components/project-report-chart';
import moment from 'moment-timezone';
import {Moment} from 'moment'
import {ProjectSummary, ReportProjectsStore} from '../../../stores/projects-store';
import FileSaver from 'file-saver';
import {EmployeesReport, EmployeesReportStore} from '../../../stores/employee-report-store';
import {GetColors} from '../../../components/employees-report-chart';
import FormItem from 'antd/lib/form/FormItem';
import {nameof} from '../../../core/utils/object';
import {FormComponentProps, GetFieldDecoratorOptions} from 'antd/lib/form/Form';
import { successNotification } from '../../../components/systemNotifications/notificationService';

const { Option } = Select;
const { RangePicker } = DatePicker

// tslint:disable-next-line:no-empty-interface
interface ProjectReportViewProps {
    companyName: string;
    companyId: string;
    isAdmin: boolean;
    employeeId?: string;
}

interface ProjectReportViewState {
    error?: string;
    projectsQuery: Query;
    timesheetsQuery: Query;
    isBusy: boolean;
    isPlotting: boolean;
    projects: ProjectSummary[];
    projectIndex: Map<string, number>;
    selectedProjectIndex: number;
    selectedProjectId: string;
    employeesReport?: EmployeesReport;
    dataColors: string[];
    fromDateStamp: number;
    toDateStamp: number;
    chartRenderToggle: boolean;
}

interface ProjectReportRequest {
    projects: ProjectSummary[];
    project?: number
    fromDateStamp: number;
    toDateStamp: number;
    from: Moment,
    to: Moment
}

interface ClassFormBodyProps extends WithTranslation {
    item: ProjectReportRequest | undefined,
    onSave?: () => Promise<any>;
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
    getFieldValue: (name: string) => any;
    validateFields: (fieldNames?: string[], options?: any, callback?: any) => void
}

class ReportFormBody extends React.Component<ClassFormBodyProps> {
    constructor(props: ClassFormBodyProps) {
        super(props);
        this.state = {
        }
    }

    @autobind
    private async validatProjectSelection(rule: any, value: any) {
        const { t } = this.props;
        if (value === undefined) {
            throw new Error(t('Project must be specified'))
        }
    }

    @autobind
    private validateDatePickerEnd(rule: any, date: Moment, callback: any) {
        var startDate = this.props.getFieldValue(nameof<ProjectReportRequest>('from'))
        var endDate = this.props.getFieldValue(nameof<ProjectReportRequest>('to'))
        if (startDate.isBefore(endDate)) {
            this.props.validateFields([nameof<ProjectReportRequest>('from')], { force: true })

            callback();
        } else {
            const { t } = this.props;
            callback(t('The final date must be greater than or equal to the initial date'));
        }

    }

    @autobind
    private validateDatePickerStart(rule: any, date: Moment, callback: any) {
        var startDate = this.props.getFieldValue(nameof<ProjectReportRequest>('from'))
        var endDate = this.props.getFieldValue(nameof<ProjectReportRequest>('to'))
        if (startDate.isBefore(endDate)) {
            this.props.validateFields([nameof<ProjectReportRequest>('to')], { force: true })
            callback();
        } else {
            const { t } = this.props;
            callback(t('The final date must be greater than or equal to the initial date'));
        }

    }

    render() {
        const { t } = this.props;
        var item = this.props.item || {} as ProjectReportRequest;

        return <Form
            layout="inline"
            id="modaForm">
            <FormItem style={{ minWidth: 300, maxWidth: 300 }}>
                <div data-tut="reactour__navegateReport1p" style={{ marginTop: -3 }}>
                    {this.props.getFieldDecorator(nameof<ProjectReportRequest>('project'), {
                        rules: [{ required: false, message: t('Projects must be specified') },
                        { validator: this.validatProjectSelection }]
                    })(
                        <Select
                            showSearch
                            className={"custom-ant-select-selection__placeholder"}
                            style={{ minWidth: 300, maxWidth: 300, height: 36 }}
                            placeholder={t('Projects')}
                            filterOption={(input, option) => {
                                if (option.props.children)
                                    return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                return false;
                            }}>
                            {this.props.item?.projects.map((value, index) => {
                                return <Option key={`${value.id}`} value={index}>{value.title}</Option>
                            })}
                        </Select>
                    )}
                </div>
            </FormItem>

            <div style={{ maxWidth: 245, whiteSpace: 'nowrap', marginLeft: 10, display: 'inline-block' }} >
                <FormItem data-tut="reactour__navegateReport2p" style={{ maxWidth: 125, display: 'inline-block', marginTop: -1 }} >

                    {this.props.getFieldDecorator(nameof<ProjectReportRequest>('from'), {
                        rules: [{ required: true, message: t('Initial date must be specified') }, { validator: this.validateDatePickerStart }],
                        initialValue: moment().startOf('month')
                    })(
                        <DatePicker
                            format='DD-MM-YYYY'
                        />
                    )}
                </FormItem>
                <FormItem data-tut="reactour__navegateReport3p" style={{ maxWidth: 125, display: 'inline-block', marginTop: -1, marginLeft: -10 }}  >
                    {this.props.getFieldDecorator(nameof<ProjectReportRequest>('to'), {
                        rules: [{ required: true, message: t('Final date must be specified') }, { validator: this.validateDatePickerEnd }],
                        initialValue: moment().endOf('month')
                    })(
                        <DatePicker
                            format='DD-MM-YYYY'
                        />
                    )}
                </FormItem>
            </div>


            <FormItem >
                <div data-tut="reactour__navegateReport4p" style={{ marginLeft: 20, marginTop: -2 }}   >
                    <Button
                        onClick={() => { if (this.props.onSave) { this.props.onSave(); } }}
                        style={{ paddingRight: 11, paddingLeft: 10 }}>
                        <Icon type='eye' />
                        {t('View report')}
                    </Button>
                </div>
            </FormItem>
        </Form>
    }
}

@connect(['projects', ReportProjectsStore], ["employeesReport", EmployeesReportStore])
class ProjectsReportDashboard extends React.Component<ProjectReportViewProps & WithTranslation & FormComponentProps, ProjectReportViewState> {
    private get projectsStore() {
        return (this.props as any).projects as ReportProjectsStore;
    }
    private get employeesReportStore() {
        return (this.props as any).employeesReport as EmployeesReportStore;
    }

    constructor(props: ProjectReportViewProps & WithTranslation & FormComponentProps) {
        super(props);

        this.state = {
            projectsQuery: {
                searchQuery: '',
                orderBy: [{ field: 'title', direction: 'Ascending', useProfile: false }],
                skip: 0,
                take: 1000,
            },
            timesheetsQuery: {
                searchQuery: '',
                orderBy: [{ field: 'fromDate', direction: 'Ascending', useProfile: true }],
                skip: 0,
                take: 1000
            },
            isBusy: false,
            isPlotting: false,
            projects: [],
            projectIndex: new Map(),
            selectedProjectIndex: -1,
            selectedProjectId: "",
            dataColors: [],
            fromDateStamp: 0,
            toDateStamp: 0,
            chartRenderToggle: false
        };
        this.projectsStore.changeUrl(props.companyId);
    }

    componentWillMount() {
        this.loadProjects(this.state.projectsQuery)
    }

    @autobind
    private loadProjects(query: Query) {
        var self = this
        var projectIndex = new Map<string, number>()
        this.setState({ isBusy: true });
        this.projectsStore.getAllAsync(query, undefined, this.props.companyId).then(result => {
            let projects = result.items as ProjectSummary[]
            projects.forEach((value, index) => { projectIndex.set(value.id, index) })

            self.setState({
                isBusy: false,
                projects: projects,
                projectIndex: projectIndex
            });
        }).catch(error => {
            this.setState({ error: formatMessage(error), isBusy: false })
        });
    }

    @autobind
    private onCreateNewItem() {
        var self = this;
        return new Promise((resolve, reject) => {
            self.props.form.validateFields(event => {
                var values = self.props.form.getFieldsValue();
                if (!event) {
                    let projectId = self.state.projects[values.project].id
                    let fromDateStamp = (values.from as Moment).startOf("day").unix();
                    let toDateStamp = (values.to as Moment).endOf("day").unix();
                    let queryTimesheets = {
                        ...self.state.timesheetsQuery,

                        parameters: {
                            'queryFromDateStamp': (values.from as Moment).clone().startOf("isoWeek").startOf("day").unix(),
                            'queryToDateStamp': (values.to as Moment).clone().endOf("isoWeek").endOf("day").unix(),
                            'fromDateStamp': fromDateStamp,
                            'toDateStamp': toDateStamp,
                        }
                    }

                    self.setState({
                        timesheetsQuery: queryTimesheets,
                        fromDateStamp: fromDateStamp,
                        toDateStamp: toDateStamp,
                        selectedProjectIndex: values.project,
                        selectedProjectId: projectId,
                    })
                    self.loadEmployeesReport(queryTimesheets, projectId)
                }
            });
        })
    }

    @autobind
    private async loadEmployeesReport(queryTimesheets: Query, projectId: string) {
        const { isAdmin } = this.props
        if (this.state.selectedProjectId.length === 0)
            return;

        this.setState({
            isBusy: true,
            isPlotting: false
        })
        if (isAdmin) this.employeesReportStore.changeUrlByAdminProject(this.props.companyId, projectId);
        else this.employeesReportStore.changeUrlByUserProject(this.props.companyId, projectId);

        await this.employeesReportStore.getAsync(queryTimesheets, { export: false }).then(result => {
            let employeesReport = result.data
            employeesReport.projectIdToName = new Map(Object.entries(employeesReport.projectIdToName).toArray())
            employeesReport.projectTaskIdToName = new Map(Object.entries(employeesReport.projectTaskIdToName).toArray())
            employeesReport.reports.forEach(report => {
                report.workedHoursPerProject = new Map(Object.entries(report.workedHoursPerProject).toArray())
                report.workedHoursPerProjectByMonth = new Map(Object.entries(report.workedHoursPerProjectByMonth).toArray())
                report.workedHoursPerTask = new Map(Object.entries(report.workedHoursPerTask).toArray())
                report.workedHoursPerTaskByMonth = new Map(Object.entries(report.workedHoursPerTaskByMonth).toArray())
            })

            this.setState({
                employeesReport: employeesReport,
                isBusy: false,
                isPlotting: (employeesReport.reports.length > 0),
                dataColors: GetColors(employeesReport.reports.length)
            });
        }).catch(error => {
            this.setState({ error: formatMessage(error), isBusy: false })
            return
        })
    }

    @autobind
    private async onDownload(format: string): Promise<boolean> {
        const { isAdmin, form } = this.props
        try {
            this.setState({ isBusy: true });
            var values = form.getFieldsValue()
            let queryTimesheets = {
                ...this.state.timesheetsQuery,
                parameters: {
                    'queryFromDateStamp': (values.from as Moment).clone().startOf("isoWeek").startOf("day").unix(),
                    'queryToDateStamp': (values.to as Moment).clone().endOf("isoWeek").endOf("day").unix(),
                    'fromDateStamp': this.state.fromDateStamp,
                    'toDateStamp': this.state.toDateStamp,
                }
            }
            let projectName: string = this.state.projects[this.state.selectedProjectIndex].title;

            if (isAdmin) this.employeesReportStore.changeUrlByAdminProject(this.props.companyId, this.state.selectedProjectId);
            else this.employeesReportStore.changeUrlByUserProject(this.props.companyId, this.state.selectedProjectId);

            var result = await this.employeesReportStore.getAsync(queryTimesheets, { responseType: 'arraybuffer', export: true, format: format, projectName: projectName });
            successNotification(this.props.t('Operation Completed Successfully'), this.props.t('Your operation will be processed in background.'));
            this.setState({ isBusy: false });
            return true;
        } catch (error) {
            this.setState({ isBusy: false, error: formatMessage(error) });
            return false;
        }
    }

    public render() {
        const { t } = this.props as any;
        const { getFieldDecorator, getFieldValue, validateFields } = this.props.form;

        let reportRequest: ProjectReportRequest = {
            projects: this.state.projects,
            project: undefined,
            fromDateStamp: this.state.fromDateStamp,
            toDateStamp: this.state.toDateStamp,
            from: moment(),
            to: moment()
        }

        return <div>
            <Spin size='large' spinning={this.state.isBusy}>
                <Row type={'flex'} align='top' justify='space-between'>
                    {this.state.error && <Alert type='error' message={this.state.error} />}
                    <div style={{ top: 0, backgroundColor: 'white', zIndex: 100, width: "100%" }}>
                        <ReportFormBody
                            i18n={this.props.i18n}
                            t={this.props.t}
                            tReady={this.props.tReady}
                            item={reportRequest}
                            getFieldDecorator={getFieldDecorator}
                            getFieldValue={getFieldValue}
                            validateFields={validateFields}
                            onSave={this.onCreateNewItem} />
                        {this.state.isPlotting &&
                            <React.Fragment>
                                <div style={{ marginTop: 20, width: "100%" }}>
                                    <ProjectReportTable
                                        data={this.state.employeesReport as EmployeesReport}
                                        onDownload={this.onDownload}
                                        projectId={this.state.selectedProjectId} />
                                </div>
                                <div style={{ marginTop: 20, width: "100%" }}>
                                    <ProjectReportChart
                                        renderToggle={this.state.chartRenderToggle}
                                        data={this.state.employeesReport as EmployeesReport}
                                        projectId={this.state.selectedProjectId}
                                        colors={this.state.dataColors}
                                        showBar={true}
                                        showPie={true} />
                                </div>
                            </React.Fragment>}
                        {!this.state.isPlotting && <Empty />}

                    </div>
                </Row>
            </Spin>
        </div>
    }
}
// Wire up the React component to the Redux store
export default withTranslation()(Form.create({})(ProjectsReportDashboard as any) as any) as any as React.ComponentClass<ProjectReportViewProps>;